import { IInspectorStore } from "./types";

const reducerState: IInspectorStore = {
	filters: {
		dateRange: {
			startDate: '',
			endDate: '',
		},
		entry: {
			id: '',
			title: '',
			type: '',
			typeOfLogs: ''
		},
	},
	logs: [],
	sealLogs: [],
	pagination: {
		count: 0,
		index: 0,
	},
	selectedLog: '',
	indexOfTasks: '',
	books: [],
	filteredBy: null,
	searchBy: '',
	showCoverPages: false,
	stateOfScriptInjection: 'IDLE',
	_jobs: {},
};

export default reducerState;
